import { genericService } from "./genericService";
import { akeronService } from "./akeronService";

const section = "Warehouse";

function filter(name = "", from = "0", limit = "10", active = "1", numContainer = "") {
  const param = {
    jtStartIndex: parseInt(from),
    jtPageSize: parseInt(limit),
    isActive: active === "1" || active === true,
    NameWarehouse: name,
    NumContainer: numContainer
  };
  
  return akeronService.make_post_request(section + "/ListWarehouse", param).then((response) => {
    let result = {
      quantity: response.quantity,
      list: response.warehouses,
    };
    return result;
  });
}

function remove(id) {
  return genericService.remove(section, id);
}

function create(item) {
  const param = {
    contact: item.contact,
    IdCountry: item.country.id,
    IdLocality: item.locality.id,
    nameWarehouse: item.nameWarehouse,
    WarehouseAddress: item.warehouseAddress,
    WarehouseEmail: item.warehouseEmail,
    WarehouseTelephone: item.warehouseTelephone,
    IdClient: item.client.id,
    isActive: item.isActive,
  };
  return genericService.create(section, param);
}

function update(item) {
  const param = {
    id: item.id,
    contact: item.contact,
    IdCountry: item.country.id,
    IdLocality: item.locality.id,
    nameWarehouse: item.nameWarehouse,
    WarehouseAddress: item.warehouseAddress,
    WarehouseEmail: item.warehouseEmail,
    WarehouseTelephone: item.warehouseTelephone,
    IdClient: item.client.id,
    isActive: item.isActive,
  };
  return genericService.update(section, param);
}

export const warehouseService = {
  filter,
  remove,
  create,
  update,
};
